'use strict';

angular.module('shiftTraderApp')
  .directive('organizationProfileTopBar', function () {
    return {
      templateUrl: 'views/organizationProfile/organizationProfileTopBar.html',
      scope: {
        org: '=organizationProfileTopBar'
      },
      bindToController: true,
      controllerAs: 'orgProfileTopBar',
      controller: function () {
        this.state = {
          phoneNumber: {
            raw: this.org.organization_config.phone_number,
            formatted: this.org.formattedPhoneNumber()
          },
          q: {}
        }
      }
    }
  })
